import { render, staticRenderFns } from "./RiaperturaMaster.vue?vue&type=template&id=cc81f250&scoped=true&"
import script from "./RiaperturaMaster.vue?vue&type=script&lang=js&"
export * from "./RiaperturaMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc81f250",
  null
  
)

export default component.exports